import { render, staticRenderFns } from "./file-browser.vue?vue&type=template&id=b7bcca72&scoped=true"
import script from "./file-browser.vue?vue&type=script&lang=js"
export * from "./file-browser.vue?vue&type=script&lang=js"
import style0 from "./file-browser.vue?vue&type=style&index=0&id=b7bcca72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bcca72",
  null
  
)

export default component.exports